<template>

	<div id="app" class="flex h-100 flex-wrap">
		<!-- 加载动画 -->
		<div class="loads" v-show="!isload">
			<div style="background-color: #fff;padding: 42px 70px 12px 42px;border-radius: 12px;">
				<el-form ref="form" label-width="90px" :model="form" :rules="rules">
					<el-form-item>
						<div style="color: #5555ff;font-weight: bold;" class="font-m">
							片材行业软件生产看板系统
						</div>
					</el-form-item>
					<el-form-item label="账套:" prop="zt">
						<el-input v-model="form.zt"></el-input>
					</el-form-item>
					<el-form-item label="账号:" prop="zh">
						<el-input v-model="form.zh"></el-input>
					</el-form-item>
					<el-form-item label="密码:" prop="pas">
						<el-input v-model="form.pas"></el-input>
					</el-form-item>

					<el-form-item>

						<el-button type="primary" @click="onSubmit" style="float: right;">确定</el-button>
						<el-button type="danger" @click="remove" style="float: right;margin-right: 10px;">清除</el-button>
					</el-form-item>
				</el-form>
			</div>

		</div>

		<header class="w-100 h-10 flex j-center a-center">
			<dv-decoration-5 :dur="10" style="position: absolute;bottom: 0;right: 0;height: 50%;" class="w-100 " />
			<div class="font-big font-weight">片材行业软件生产看板系统-<span
					style="color: #ff0000;cursor: pointer;margin-right: 15px;" @click="handleTc">{{form.zt}}</span>
			</div>
			<screenfull id="screenfull" class="right-menu-item hover-effect" />
		</header>

		<div class=" w-100 h-65 " v-if="isload">
			<div class="w-100 h-100  flex j-sb flex-wrap">
				<table1 :domain="domain"></table1>
				<table2 :domain="domain"></table2>
				<table3 :domain="domain"></table3>
				<table4 :domain="domain"></table4>

			</div>


		</div>
		<div class="p w-100 h-25 " v-if="isload">
			<bottom-item :domain="domain"></bottom-item>



		</div>


	</div>
</template>

<script>
	import Cookies from 'js-cookie'
	import table1 from "./views/片材/table1.vue"
	import table2 from "./views/片材/table2.vue"
	import table3 from "./views/片材/table3.vue"
	import table4 from "./views/片材/table4.vue"
	import bottomItem from "./views/片材/bottom_item.vue"
	import Screenfull from './components/Screenfull/index.vue'
	export default {
		components: {
			table1,
			table2,
			table3,
			table4,
			bottomItem,
			Screenfull
		},
		name: "App",
		data() {
			return {
				rules: {
					zt: [{
						required: true,
						message: '必选项不能为空',
						trigger: 'blur'
					}, ],
					zh: [{
						required: true,
						message: '必选项不能为空',
						trigger: 'blur'
					}, ],
					pas: [{
						required: true,
						message: '必选项不能为空',
						trigger: 'blur'
					}, ],
				},

				form: {
					pas: "",
					zh: "",
					zt: ""
				},
				key: "",
				zt: "",
				isload: false,
				domain: ""
			}
		},
		created() {



			this.fnload(); //加载
		},
		methods: {
			remove() {
				this.form = {

				}
				Cookies.remove('form')
			},

			handleTc() {

				this.isload = false
			},

			fnload() {
				// this.isload = true;


				let key = Cookies.get('form')
				console.log(key);

				if (key) {
					this.form = JSON.parse(key)
					this.onSubmit()
				} else {
					// this.isload = true;
				}

				// const timeout = setTimeout(() => {
				// 	this.isload = false;
				// }, 3000);
			},
			login(apps) {
				let url = `${this.domain}/fileZgb/doLogin`
				this.$axios.post(url, {
					phone: this.form.zh,
					password: this.form.pas,
					apps: apps
				}).then(res => {

					if (res.data.code == -1) {
						this.msgError(res.data.msg)
					} else {
						this.isload = true;
					}
					Cookies.set("form", JSON.stringify(this.form), {
						expires: 7
					})

				})
			},

			onSubmit() {
                let that=this
				that.$refs.form.validate((valid) => {
					if (valid) {
						that.$axios.get(`https://app.srdrjbz.cn:8086/factory/queryFactoryByDm/${that.form.zt}`).then(res => {
							console.log(res);
							if (res.data.code == -1) {
								that.msgError(res.data.msg)
							} else {
						
								that.domain = res.data.data.domain
						
								that.login(res.data.data.ywdrs)
							}
						})

					} else {
						// alert('不能为空');
						return false;
					}
				});


		
				
			}
		}
	};
</script>

<style !important>
	.loads {
		background: #06164A;
		z-index: 999;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0%;
		top: 0%;
		background-size: cover;
		display: flex;
		justify-content: center;
		align-items: center;

	}

	header {
		background: url(assets/img/head_bg.png);
		background-size: 100% 100%;
		position: relative;

	}

	/* 媒体查询  */
	@media screen and (max-width: 1024px) {
		html {
			font-size: 42px !important;
		}
	}

	@media screen and (min-width: 1920px) {
		html {
			font-size: 80px !important;
		}
	}

	/* 主题色 */
	.color-blue {
		color: #1FE9E8;
	}

	.color-gray {
		color: #CDEAF6;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue